export const labelToKeyMap = {
  // Generales
  "Booking ID": "booking_id",
  "Collected value": "collected_value",
  "Created at": "created_at",
  "Data": "event_date",
  "Data de criação": "created_at",
  "Data e hora": "timestamp",
  "Date": "event_date",
  "Declared value": "declared_value",
  "Delivery photo": "delivered",
  "Destination address": "end_address",
  "Dirección de destino": "end_address",
  "Dirección de origen": "address",
  "Driver": "driver",
  "Endereço de destino": "end_address",
  "Endereço de origem": "address",
  "Estatus": "status",
  "Event": "event_name",
  "Evento": "event_name",
  "Eventos": "events",
  "Events": "events",
  "Evidences": "evidences",
  "Evidencias": "evidences",
  "Evidências": "evidences",
  "Fecha": "event_date",
  "Fecha de creación": "created_at",
  "Fecha y hora": "timestamp",
  "Foto de coleta": "picked",
  "Foto de coleta (opcional)": "optional_picked",
  "Foto de entrega": "delivered",
  "Foto de entrega (opcional)": "optional_delivered",
  "Foto de recolección": "picked",
  "Foto de recolección (opcional)": "optional_picked",
  "Hora": "hour",
  "Hour": "hour",
  "ID del servicio": "booking_id",
  "ID do serviço": "booking_id",
  "Indicaciones": "indications",
  "Indications": "indications",
  "Link de rastreamento": "tracking_link",
  "Link de rastreo": "tracking_link",
  "redirect_url": "tracking_link",
  "Mensagem": "message",
  "message": "message",
  "Mensagens": "messages",
  "Mensaje": "message",
  "Mensajes": "messages",
  "Message": "message",
  "Messages": "messages",
  "Motorista": "driver",
  "Número de ticket": "ticket_number",
  "Número do ticket": "ticket_number",
  "Observações": "indications",
  "Optional delivery photo": "optional_delivered",
  "Optional pickup photo": "optional_picked",
  "Origin address": "address",
  "Packages": "packages",
  "Pacotes": "packages",
  "Paquetes": "packages",
  "Pickup photo": "picked",
  "Piloto": "driver",
  "Reference": "reference",
  "Referencia": "reference",
  "Referência": "reference",
  "Status": "status",
  "Termos e condições": "terms_link",
  "Terms and conditions": "terms_link",
  "Ticket number": "ticket_number",
  "Timestamp": "timestamp",
  "Tipo de solicitação": "type_of_request",
  "Tipo de solicitud": "type_of_request",
  "Title": "title",
  "Tracking link": "tracking_link",
  "Type of request": "type_of_request",
  "Términos y condiciones": "terms_link",
  "Título": "title",
  "Valor cobrado": "collected_value",
  "Valor coletado": "collected_value",
  "Valor declarado": "declared_value",
  "Vehicle": "vehicle",
  "Vehículo": "vehicle",
  "Veículo": "vehicle",

  // Subcampos Piloto / Vehículo
  "Nombre": "name",
  "Name": "name",
  "Nome": "name",
  "Teléfono": "phone",
  "Phone": "phone",
  "Telefone": "phone",
  "Calificación": "rating",
  "Rating": "rating",
  "Avaliação": "rating",
  "Foto": "photo_url",
  "Photo": "photo_url",
  "Placas": "plates",
  "Plates": "plates",
  "Marca": "make",
  "Make": "make",
  "Modelo": "model",
  "Model": "model",
  "Color": "color",
  "Cor": "color",
  "Ícono": "marker_icon",
  "Ícone": "marker_icon",
  "Marker icon": "marker_icon"
};

export function getIconForField(field) {
  const iconMap = {
    // Ubicaciones
    address: '📍',
    secondary_address: '📍',
    end_address: '📍',
    headquarters: '🏢',
    origin_address: '📍',
    rend_address: '📍',

    // Fechas
    created_at: '📅',
    updated_at: '📅',
    scheduled_at: '🗓️',
    rend_at: '📆',
    timestamp: '📆',
    event_date: '📆',
    pickup_at: '🕑',
    hour: '🕑',

    // Estado
    status: '🔄',
    status_cd: '🔢',

    // Costos
    final_cost: '💰',
    company_final_cost: '🏢💰',
    estimated_cost: '📊',
    company_estimated_cost: '🏢📊',
    money_to_pay_for_package: '💵',
    collected_value: '💵',
    declared_value: '💵',
    discount_with_promo_balance: '🏷️',
    discount_with_piprime: '🏷️',
    discount_with_franchise_promo: '🏷️',

    // Pasajero / usuario
    passenger: '🧍',
    phone: '📞',
    email: '✉️',
    name: '👤',
    passenger_name: '🧍‍♂️',
    passenger_id: '🆔',

    // Paquetes
    packages: '📦',
    package: '📦',
    reference: '🏷️',
    weight: '⚖️',
    indications: '📝',
    size_cd: '📐',
    validation_code: '🔐',
    counter_delivery: '🔁',

    // Paradas
    stops: '🛑',
    is_return_stop: '🔁',
    finished: '✅',
    customer: '🧑‍💼',

    // Cliente dentro de stops
    country_code: '🌐',
    city: '🏙️',
    city_id: '🏙️',

    // Viaje / ruta
    trv_distance_str: '📏',
    trv_time_str: '⏱️',
    route_info: '🛣️',
    estimated_traveled_distance: '📏',
    estimated_traveled_time: '⏱️',
    origin_geojson: '🧭',
    end_geojson: '🧭',
    use_wallet_balance: '👛',

    // Métodos de pago
    payment_method_cd: '💳',
    payment_card_id: '💳',
    payment_status: '💳✅',

    // Vehículo / conductor
    driver: '🚗',
    vehicle: '🚘',
    vehicle_type_id: '🚙',
    plates: '🔤',
    make: '🚘',
    model: '🚘',
    color: '🎨',
    marker_icon: '🧭',
    rating: '⭐',
    photo_url: '🖼️',

    // Empresa y centro de costo
    company: '🏢',
    cost_center: '🏷️',

    // PQRs
    type_of_request: '📄',
    ticket_number: '🎫',
    complaint_letter: '📑',
    invoice_and_bank_certification: '🧾',
    messages: '💬',
    message: '💬',
    mssg: '💬',
    document: '📎',

    // Otros
    relaunched_to: '🔁',
    booking_reservation_id: '📝',
    express_service: '⚡',
    promo_code_info: '🎟️',
    volume: '📦',
    booking_id: '🆔',
    tracking_link: '🔗',
    status_reason: '📋',
    delivery_code: '🔢'
  };

  const key = field.toLowerCase();

  if (iconMap[key]) return iconMap[key];

  const normalizedKey =
    labelToKeyMap[field] ||
    Object.entries(labelToKeyMap).find(([label]) => label.toLowerCase() === key)?.[1];

  return iconMap[normalizedKey] || '🔸';
}

export function buildDynamicOptionName(item) {
  const lines = [];

  function processEntry(key, value) {
    if (key === 'id' || value === null || value === undefined) return;

    const fieldKey =
      labelToKeyMap[key] ||
      Object.entries(labelToKeyMap).find(([label]) => label.toLowerCase() === key.toLowerCase())?.[1] ||
      key;

    const icon = getIconForField(fieldKey);
    const isDate = /(date|_at)$/i.test(fieldKey);
    const displayValue =
      typeof value === 'string' && isDate
        ? new Date(value).toLocaleDateString()
        : value;

    const label = `${icon} ${capitalize(key)}: ${displayValue}`;
    lines.push(label);
  }

  Object.entries(item).forEach(([key, value]) => {
    if (Array.isArray(value) && typeof value[0] === 'object') {
      value.slice(0, 1).forEach((obj) => {
        Object.entries(obj).forEach(([subKey, subValue]) => {
          processEntry(subKey, subValue);
        });
      });
    } else if (typeof value === 'object' && value !== null) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        processEntry(subKey, subValue);
      });
    } else {
      processEntry(key, value);
    }
  });

  return lines.join('\n');
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
